import { render, staticRenderFns } from "./labAssignmentBox.vue?vue&type=template&id=6a25502c&scoped=true"
import script from "./labAssignmentBox.vue?vue&type=script&lang=js"
export * from "./labAssignmentBox.vue?vue&type=script&lang=js"
import style0 from "./labAssignmentBox.vue?vue&type=style&index=0&id=6a25502c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a25502c",
  null
  
)

export default component.exports